import { useEffect } from 'react';
import { MapContainerProps, useMap } from 'react-leaflet';

export const ControlFlow: React.FC<Pick<MapContainerProps, 'center' | 'zoom'>> = ({ center, zoom }) => {
  const map = useMap();

  useEffect(() => {
    // @ts-ignore
    window.map = map;
  }, []);

  useEffect(() => {
    center &&
      map.flyTo(center, zoom, {
        duration: 1.5,
      });
  }, []);

  return null;
};
